const numberFormatter = new Intl.NumberFormat('pt-BR');
const variationFormatter = new Intl.NumberFormat('pt-BR', { signDisplay: 'always' });

export function formatNumber(value: number): string {
  return numberFormatter.format(value);
}

export function formatVariationPct(variationPct: number): string {
  return `${variationFormatter.format(variationPct)}%`;
}

export function formatDays(days: number): string {
  const rounded = Math.round(days);
  return `${formatNumber(rounded)} ${rounded === 1 ? 'dia' : 'dias'}`;
}
